import type { CmsMessage } from '@gov-nx/api';
import { useAxiosCmsInstance, useCmsMessagesQuery } from '@gov-nx/api';
import { GovError } from '@gov-nx/core/app';

export interface CmsMessageLoaderProps {
	onSuccess?: (messages: CmsMessage[]) => void;
	onError?: (error: Error) => void;
}

export const useCmsMessageLoader = (props?: CmsMessageLoaderProps) => {
	const { axiosCmsInstance } = useAxiosCmsInstance();
	const query = useCmsMessagesQuery(axiosCmsInstance, {
		onError: (message: string) => {
			props?.onError && props?.onError(new GovError(message));
		},
		onSuccess: (data) => props?.onSuccess && props?.onSuccess(data),
	});

	return { messageQuery: query, messages: query.data ?? [] };
};
